export enum AccountTypes {
    OFFLINE = 0,
    ONLINE = 1
}

export enum UserTypes {
	PRIMARY = 0,
	SECONDARY = 1
}
